module.exports = __webpack_public_path__ + "static/raender-054f213e785d6524ad7469e7901c8aa3.png";